import React, { useCallback, useContext } from 'react';
import { Helmet } from 'react-helmet';
import SchemeDashboard from '../../../PerksHub/SchemeDashboard';
import { SidebarContext } from '../../../../context/SidebarContext';
import { useCompanySectionFilter } from '../../../../component/B2B/CompanySectionLayout';
import { CHART_COLORS } from '../../../../component/common/designSystem';
import { fetchSalarySacrifice } from './companyPerksApi';

/** Company Perks → Salary Sacrifice: schemes on offer and who is enrolled. */
const CPerksSalarySacrifice = () => {
  const { isB2BFansMode } = useContext(SidebarContext);
  const { department } = useCompanySectionFilter();

  const fetcher = useCallback(
    () => fetchSalarySacrifice(department),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isB2BFansMode, department]
  );

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Salary Sacrifice | Shoorah</title>
      </Helmet>
      <SchemeDashboard
        fetcher={fetcher}
        title="Salary Sacrifice"
        noun="scheme"
        accent={CHART_COLORS.brand}
        populationLabel={isB2BFansMode ? 'members' : 'employees'}
      />
    </div>
  );
};

export default CPerksSalarySacrifice;
